export default function SearchBar() {
    return (
      <div className="SearchBar">
        <input className="Input" type="text" placeholder="Search..." />
      </div>
    );
  }
  